import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '../../ui-kit';
import { IconDisplay, IconExclamationTriangle } from '../../ui-kit/icons';

// This component allows to manually select which mode to display in the dashboard.
// This is the mechanism used to toggle between normal mode and incident mode during
// dashboard edition.
const DashboardModePicker = ({ activateNormalMode, activateIncidentMode, incidentMode }) => (
  <ToggleButtonGroup
    name="dashboard-mode"
    type="radio"
    value={incidentMode ? 'incident' : 'normal'}
    className="me-2"
    onChange={value => (value == 'incident' ? activateIncidentMode() : activateNormalMode())}
  >
    <ToggleButton
      id="dashboard-normal-mode"
      variant="outline-info"
      value="normal"
      title={I18n.t('dashboards.normal_mode')}
    >
      <IconDisplay />
    </ToggleButton>
    <ToggleButton
      id="dashboard-incident-mode"
      variant="outline-danger"
      value="incident"
      title={I18n.t('dashboards.incident_mode')}
    >
      <IconExclamationTriangle />
    </ToggleButton>
  </ToggleButtonGroup>
);

export default DashboardModePicker;
